import LandingPage from './components/LandingPage'
import PepperRodeo from './components/Projects/PepperRodeo'

const routes = [
    {path: '/', component: LandingPage},
    {path: '/pepper-rodeo', component: PepperRodeo}
];

export default routes;
